type WarehouseCompany = 'stahlia' | 'priostahl'
export const palletReplaceHeaders = { 'X-Stahlia-Pallet-Replace-Contract': 'cross-company-v1' }
export interface PalletPlaceConfirmation {
  place: { id: number; barcode: string }
  occupant: {
    company?: WarehouseCompany
    position_id: number
    palette_no: string | null
    article: string | null
    qty_exact: number | null
    qty_circa: number | null
  }
  incoming?: { company?: WarehouseCompany; palette_no: string | null; article: string | null; quantity: number | null }
  cross_company?: boolean
  confirm_token: string
}
/** Only the occupied-place contract can open a replacement question. */
export function palletPlaceConfirmation(
  code: string | undefined,
  details: unknown,
): PalletPlaceConfirmation | null {
  if (code !== 'place_occupied' && code !== 'place_occupant_changed') return null
  const c = (details as { confirmation?: PalletPlaceConfirmation } | null)?.confirmation
  const quantity = (v: unknown) => v === null || (typeof v === 'number' && Number.isFinite(v))
  const company = (v: unknown) => v === 'stahlia' || v === 'priostahl'
  if (
    !c ||
    !Number.isInteger(c.place?.id) ||
    typeof c.place?.barcode !== 'string' ||
    !c.place.barcode ||
    !Number.isInteger(c.occupant?.position_id) ||
    c.occupant.position_id <= 0 ||
    !(c.occupant.palette_no === null || typeof c.occupant.palette_no === 'string') ||
    !(c.occupant.article === null || typeof c.occupant.article === 'string') ||
    !quantity(c.occupant.qty_exact) ||
    !quantity(c.occupant.qty_circa) ||
    typeof c.confirm_token !== 'string' ||
    !c.confirm_token
  )
    return null
  if (('cross_company' in c || 'company' in c.occupant || (c.incoming && typeof c.incoming === 'object' && 'company' in c.incoming)) &&
    (typeof c.cross_company !== 'boolean' || !company(c.occupant.company) || !c.incoming || !company(c.incoming.company) ||
      !(c.incoming.palette_no === null || typeof c.incoming.palette_no === 'string') ||
      !(c.incoming.article === null || typeof c.incoming.article === 'string') || !quantity(c.incoming.quantity))) return null
  return c
}
export function palletPlaceQuestion(c: PalletPlaceConfirmation) {
  const q =
    c.occupant.qty_exact ??
    (c.occupant.qty_circa === null ? 'unbekannt' : `ca. ${c.occupant.qty_circa}`)
  const company = (v: WarehouseCompany) => v === 'priostahl' ? 'Priostahl' : 'Stahlia'
  const incoming = c.incoming?.company
    ? ` Neue Palette: ${company(c.incoming.company)}, ${c.incoming.palette_no ?? 'unbekannt'} · ${c.incoming.article ?? 'unbekannt'} · Menge ${c.incoming.quantity ?? 'unbekannt'}.` : ''
  return `Platz ${c.place.barcode} ist belegt: ${c.occupant.company ? company(c.occupant.company) + ', ' : ''}Palette ${c.occupant.palette_no ?? 'unbekannt'} · ${c.occupant.article ?? 'unbekannt'} · Menge ${q}.${incoming} Hier abstellen und alte Palette auslagern?`
}
export function palletReplaceBody(
  body: Record<string, unknown>,
  c: PalletPlaceConfirmation,
): Record<string, unknown> {
  return { ...body, replace: { position_id: c.occupant.position_id, token: c.confirm_token } }
}
